<template>
  <div>
    <v-select
      :value="regionId"
      :items="regions"
      item-text="name"
      item-value="id"
      label="Region"
      outlined
      dense
      :rules="required ? [must] : []"
      @change="onRegion"
    ></v-select>
    <v-select
      :value="cityId"
      :items="cities"
      item-text="name"
      item-value="id"
      label="City / town"
      outlined
      dense
      :disabled="!regionId"
      :rules="required ? [must] : []"
      @change="onCity"
    ></v-select>
    <v-text-field
      v-if="showArea"
      :value="area"
      label="Area"
      outlined
      dense
      :rules="required ? [must] : []"
      @input="$emit('update:area', $event)"
    ></v-text-field>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    regionId: { default: null },
    cityId: { default: null },
    area: { type: String, default: '' },
    required: { type: Boolean, default: true },
    showArea: { type: Boolean, default: true },
  },
  data() {
    return {
      regions: [],
      cities: [],
    }
  },
  computed: {
    must() {
      return (v) => !!v || 'Required'
    },
  },
  watch: {
    regionId(id) {
      if (id) this.loadCities(id)
    },
  },
  async mounted() {
    const res = await axios.get('/locations/regions')
    this.regions = res.data.regions || []
    if (this.regionId) this.loadCities(this.regionId)
  },
  methods: {
    async loadCities(regionId) {
      const res = await axios.get('/locations/cities', { params: { region_id: regionId } })
      this.cities = res.data.cities || []
    },
    onRegion(id) {
      this.$emit('update:regionId', id)
      this.$emit('update:cityId', null)
      const region = this.regions.find((r) => r.id === id)
      if (region && region.lat) {
        this.$emit('center', { lat: Number(region.lat), lng: Number(region.lng) })
      }
      this.loadCities(id)
    },
    onCity(id) {
      this.$emit('update:cityId', id)
      const city = this.cities.find((c) => c.id === id)
      if (city && city.lat) {
        this.$emit('center', { lat: Number(city.lat), lng: Number(city.lng) })
      }
    },
  },
}
</script>
